function ean13Checksum(digits12) {
  let total = 0;
  for (let i = 0; i < digits12.length; i++) {
    total += Number(digits12[i]) * (i % 2 === 1 ? 3 : 1);
  }
  return String((10 - (total % 10)) % 10);
}

export function normalizeEan13(raw) {
  const digits = String(raw ?? "").replace(/\D/g, "");
  const base = digits.length >= 12 ? digits.slice(0, 12) : digits.padStart(12, "0");
  return base + ean13Checksum(base);
}

const L_CODES = { 0: "0001101", 1: "0011001", 2: "0010011", 3: "0111101", 4: "0100011", 5: "0110001", 6: "0101111", 7: "0111011", 8: "0110111", 9: "0001011" };
const G_CODES = { 0: "0100111", 1: "0110011", 2: "0011011", 3: "0100001", 4: "0011101", 5: "0111001", 6: "0000101", 7: "0010001", 8: "0001001", 9: "0010111" };
const R_CODES = { 0: "1110010", 1: "1100110", 2: "1101100", 3: "1000010", 4: "1011100", 5: "1001110", 6: "1010000", 7: "1000100", 8: "1001000", 9: "1110100" };
const PARITY = { 0: "LLLLLL", 1: "LLGLGG", 2: "LLGGLG", 3: "LLGGGL", 4: "LGLLGG", 5: "LGGLLG", 6: "LGGGLL", 7: "LGLGLG", 8: "LGLGGL", 9: "LGGLGL" };

export function encodeEan13Bits(code13) {
  const parity = PARITY[code13[0]];
  let bits = "101";
  for (let i = 0; i < 6; i++) {
    const d = code13[i + 1];
    bits += parity[i] === "L" ? L_CODES[d] : G_CODES[d];
  }
  bits += "01010";
  for (let i = 7; i < 13; i++) bits += R_CODES[code13[i]];
  bits += "101";
  return bits;
}

export function barcodeBars(upc, w, h) {
  const code13 = normalizeEan13(upc);
  const bits = encodeEan13Bits(code13);
  const n = bits.length;
  const textH = h * 0.22;
  const barH = h - textH;
  const moduleW = w / n;
  const bars = [];
  for (let i = 0; i < n; i++) {
    if (bits[i] === "1") bars.push({ x: i * moduleW, width: moduleW });
  }
  const grouped = `${code13[0]}  ${code13.slice(1, 7)}  ${code13.slice(7, 13)}`;
  return { bars, barH, textH, grouped };
}

export function waveBackgroundPath(w, h) {
  const waveTop = h * 0.76;
  return `M0,${waveTop.toFixed(2)} C${(w * 0.22).toFixed(2)},${(h * 0.62).toFixed(2)} ${(w * 0.68).toFixed(2)},${(h * 0.98).toFixed(2)} ${w.toFixed(2)},${(h * 0.7).toFixed(2)} L${w.toFixed(2)},${h.toFixed(2)} L0,${h.toFixed(2)} Z`;
}

export function textAnchorX(x, width, align) {
  if (align === "center") return { anchor: "middle", tx: x + width / 2 };
  if (align === "right") return { anchor: "end", tx: x + width };
  return { anchor: "start", tx: x };
}

export function textLines(text) {
  return String(text ?? "").split("\n");
}

export function cfgFor(elementConfig, key, custom) {
  const base = (elementConfig || {})[key];
  if (!base) return null;
  const override = (custom?.positions || {})[key];
  return override ? { ...base, ...override } : base;
}
